module.exports = __webpack_public_path__ + "img/reset.66bbfc2e.svg";